import styled, { keyframes } from 'styled-components';

export const IframeVideo = styled.iframe`
  width: 100%;
  max-width: 560px;
  height: 100%;
  max-height: ${(props) => (props.aplus ? 'auto' : '560px')};
  min-height: ${(props) => (props.aplus ? 'auto' : '360px')};
  aspect-ratio: 16/16;
  margin-bottom: 2px;
`;

export const ImageGalleryCover = styled.div`
  position: relative;

  .videoPlayerDiv {
    background: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp')
      50% center / cover no-repeat;
    height: 100%;
    top: 2px;

    @media (max-width: 720px) {
      position: relative;
      top: 0px;
    }
  }

  .defaultImageDiv {
    background: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp')
      50% center / cover no-repeat;
    height: 100%;
    padding-top: 100%;
    border-radius: 16px;
    top: 2px;

    @media (max-width: 720px) {
      position: relative;
      top: 0px;
      padding-top: 100%;
    }

    img {
      border-radius: ${(props) => (props.fromResult ? '10px !important' : '0')};
    }
  }

  .customImageDiv {
    height: 100%;
    padding-top: 100%;
    border-radius: 16px;

    @media (max-width: 720px) {
      padding-top: 100%;
    }
  }

  .ImagePlayButton {
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 60px;
    max-height: 60px;
    transform: translate(-50%, -50%);
    z-index: 9;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  .ThumbPlayButton {
    position: absolute;
    top: 30%;
    left: 30%;
    max-width: 30px;
    max-height: 30px;
    z-index: 9;
  }

  .mainImage {
    object-fit: cover !important;
    height: 100% !important;
    position: absolute;
    top: 0;
    left: 0;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  @media (max-width: 720px) {
    padding-bottom: ${(props) => (props.showClinicData ? '10px' : '0')};
  }

  .image-gallery-image {
    border-radius: 16px;

    @media (max-width: 720px) {
      border-radius: 0;
    }
  }

  .image-gallery-slide .image-gallery-description {
    position: absolute;
    background: transparent;
    color: #272626;
    bottom: 0;
  }

  .image-gallery-play-button {
    right: 0;
    left: auto;
    bottom: 50px;
    display: none;
  }

  .image-gallery-fullscreen-button {
    display: none;
  }

  .image-gallery-content.fullscreen {
    background: #f6f6f6;
    padding: 60px 0;

    .image-gallery-image {
      max-height: calc(100vh - 140px) !important;
    }

    @media (max-width: 720px) {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      height: 100%;
      line-height: 60px;
      background: #f6f6f6;
      padding: 0;
    }
  }
`;

export const StickyDiv = styled.div`
  position: sticky;
  top: 200px;
  z-index: 16;

  @media (max-width: 720px) {
    position: static;
  }
`;

export const VideoPlayIcon = styled.img`
  position: absolute;
  top: 30%;
  left: 30%;
  max-width: 30px;
  max-height: 30px;
`;

export const UsersImageCarouselSection = styled.section`
  margin: ${(props) => (props.thumbDesign ? 0 : '1% 0 0 1%')};
  background-color: white;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  max-height: 100%;
  min-height: 100%;
  max-width: 99%;
  min-width: 99%;

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @media (min-width: 768px) {
    margin: 1% 0 0;
    max-width: 100%;
    min-width: 100%;
  }
`;

export const SeeAllUserImagesButton = styled.button`
  width: 99%;
  padding: 10px 0;
  border-radius: 6px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 5px;
  color: #ef4e5e;
  font-weight: 600;
  border: 2px solid #ef4e5e;
  position: relative;
  margin-top: 82%;
  overflow: hidden;
  @media (min-width: 768px) {
    cursor: pointer;
    width: 98%;
  }

  .rippleBlack {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: rgb(5 5 5 / 20%);
  }

  img {
    transform: rotate(270deg);
  }
`;

export const UserImagesDiv = styled.div`
  display: flex;
  column-gap: 10px;
  min-height: 100%;
  max-height: 100%;
  cursor: pointer;

  .left_side {
    flex-basis: 70%;

    img {
      object-fit: cover;
      border-radius: 6px;
    }

    span {
      top: ${(props) => (props.thumbDesign ? '7.5%' : 0)} !important;
      max-width: 68%;
      min-width: 68%;
      max-height: 85%;
      min-height: 85%;
      background: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp')
        50% center / cover no-repeat !important;
      border-radius: 6px;
    }
  }

  .one_style span {
    max-width: 97%;
    min-width: 97%;
  }

  .two_style span {
    max-width: 47%;
    min-width: 47%;
  }

  .right_side {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    flex-basis: 30%;

    img {
      object-fit: cover;
      border-radius: 6px;
      flex-basis: 50%;
    }

    .two_style span {
      left: 50% !important;
      top: ${(props) => (props.thumbDesign ? '7.5%' : 0)} !important;
      max-width: 48%;
      min-width: 48%;
      max-height: 85%;
      min-height: 85%;
    }

    .first_div {
      span {
        left: 70% !important;
        top: ${(props) => (props.thumbDesign ? '7.5%' : 0)} !important;
        max-width: 29%;
        min-width: 29%;
        max-height: 42%;
        min-height: 42%;
        border-radius: 6px;
        background: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp')
          50% center / cover no-repeat !important;
        @media (min-width: 768px) {
          max-width: 28%;
          min-width: 28%;
        }
      }
    }

    .second_div {
      span {
        right: 0;
        top: ${(props) => (props.thumbDesign ? '51.5%' : '44%')} !important;
        left: 70% !important;
        bottom: 0;
        max-width: 29%;
        min-width: 29%;
        max-height: 41%;
        min-height: 41%;
        position: absolute;
        background-color: rgb(128 128 128 / 60%);
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-weight: 500;
        border-radius: 6px;
        background: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp')
          50% center / cover no-repeat !important;
        @media (min-width: 768px) {
          max-width: 28%;
          min-width: 28%;
        }
      }

      div {
        right: 0;
        top: ${(props) => (props.thumbDesign ? '51.5%' : '44%')} !important;
        left: 70% !important;
        bottom: 0;
        max-width: 29%;
        min-width: 29%;
        max-height: 41%;
        min-height: 41%;
        position: absolute;
        background-color: rgb(128 128 128 / 60%);
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-weight: 500;
        border-radius: 6px;
        @media (min-width: 768px) {
          max-width: 28%;
          min-width: 28%;
        }
      }
    }
  }
`;

export const Controls = styled.img`
  position: absolute;
  right: ${(props) => (props.right ? '0' : 'right')};
  left: ${(props) => (props.right ? 'unset' : '0')};
  top: ${(props) => props.top || 47}%;
  z-index: 9;
  width: 42px !important;
  height: 66px !important;
  @media (max-width: 720px) {
    width: 60px !important;
    height: 66px !important;
  }
  pointer-events: all !important;

  &.lowOpacity {
    opacity: 0.4;
  }
`;
export const CarouselDotsWrapper = styled.div`
  .defaultImageDiv {
    background: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp')
      50% center / cover no-repeat;
    height: 100%;
    padding-top: 100%;
    border-radius: 16px;
    top: 2px;

    @media (max-width: 720px) {
      position: relative;
      top: 0px;
      padding-top: 100%;
    }
  }

  .customImageDiv {
    height: 100%;
    padding-top: 100%;
    border-radius: 16px;

    @media (max-width: 720px) {
      padding-top: 100%;
    }
  }

  .ImagePlayButton {
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 60px;
    max-height: 60px;
    transform: translate(-50%, -50%);
    z-index: 9;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  .mainImage {
    object-fit: cover !important;
    height: 100% !important;
    position: absolute;
    top: 0;
    left: 0;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  @media (max-width: 720px) {
    padding-bottom: ${(props) => (props.showClinicData ? '10px' : '0')};
  }

  .image-gallery-image {
    border-radius: 16px;

    @media (max-width: 720px) {
      border-radius: 0;
    }
  }

  .image-gallery-play-button {
    right: 0;
    left: auto;
    bottom: 50px;
    display: none;
  }

  .image-gallery-fullscreen-button {
    display: none;
  }

  .image-gallery-content.fullscreen {
    background: #f6f6f6;
    padding: 60px 0;

    .image-gallery-image {
      max-height: calc(100vh - 140px) !important;
    }

    @media (max-width: 720px) {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      height: 100%;
      line-height: 60px;
      background: #f6f6f6;
      padding: 0;
    }
  }

  .image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
    @media (max-width: 720px) {
      margin: 14px 2px;
      display: ${(props) => (props.showClinicData ? 'none' : '')};
    }
  }

  .image-gallery-thumbnails {
    padding: 3px 10px 3px 0;
  }

  .image-gallery-thumbnail + .image-gallery-thumbnail {
    margin-left: 5px;
  }
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translate(0px);
    }
    to {
        opacity: 1;
        transform: translate(0);
    }
`;

export const PriceUnitStripContainer = styled.div`
  background-color: ${(props) => props.textBgColor};
  color: ${(props) => props.textColor};
  height: 12%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const PriceUnitStrip = styled.div`
  font-weight: 500;
  font-size: 16px;
  animation: ${fadeIn} 1s ease-in-out;
  transition: all 0.4s ease-in-out;

  .strikeprice {
    text-decoration: line-through;
    font-weight: 400;
  }

  .price {
    font-size: 21px;
    padding-left: 4px;
  }
`;

export const ImageThumbnails = styled.div`
  .image-gallery-thumbnail-inner {
    background: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp')
      50% center / cover no-repeat;
    height: 100%;
    padding-top: 100%;
    border-radius: 4px;
    overflow: hidden;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  .image-gallery-thumbnail {
    width: 74px;
    border-radius: 6px;
  }

  .image-gallery-thumbnails-wrapper.left {
    display: ${(props) => (props.showClinicData ? 'none' : '')};
  }

  .image-gallery-thumbnail.active,
  .image-gallery-thumbnail:focus,
  .image-gallery-thumbnail:hover {
    border: 3px solid #ef4e5e;
  }

  .image-gallery-thumbnail.active:hover {
    border: 3px solid #ef4e5e;
  }

  @media (hover: hover) and (pointer: fine) {
    .image-gallery-thumbnail:hover {
      outline: none;
      border: 4px solid transparent;
    }
  }

  .image-gallery-thumbnail .image-gallery-thumbnail-image {
    width: 68px;
    height: 68px;
    border-radius: 4px;
    object-fit: cover;
  }

  .image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
    @media (max-width: 720px) {
      margin: 14px 2px;
      display: ${(props) => (props.showClinicData ? 'none' : '')};
    }
  }

  .image-gallery-thumbnails {
    padding: 3px 10px 3px 0;
  }

  .image-gallery-thumbnail + .image-gallery-thumbnail {
    margin-left: 5px;
  }

  &.dotsThumbnail {
    .image-gallery-thumbnails {
      padding: 0 10px 10px 0;
    }

    .image-gallery-thumbnail {
      width: 8px;
      border: none;
      position: relative;
      margin-right: 5px;
      height: 8px;
    }

    .carousel-dots {
      width: 8px;
      border-radius: 6px;
      height: 8px;
      background: #e5e7e7;
    }

    .carousel-dots.active,
    .carousel-dots:focus,
    .carousel-dots:hover {
      background: #ef4e5e;
    }

    .carousel-dots.active:hover {
      background: #ef4e5e;
    }

    @media (hover: hover) and (pointer: fine) {
      .carousel-dots:hover {
        outline: none;
        border: 4px solid transparent;
      }
    }

    .transparent {
      border-top: 5px solid transparent;
      border-left: 10px solid #e5e7e7;
      border-bottom: 5px solid transparent;
    }

    .transparent.active:hover,
    .transparent.active,
    .transparent:focus,
    .transparent:hover {
      border-left: 8px solid #ef4e5e;
    }

    .transparent-active {
      border-left: 8px solid #ef4e5e;
    }

    .dots-active {
      background: #ef4e5e;
      width: 8px;
      height: 8px;
      border-radius: 6px;
    }

    .dots-active:active,
    .dots-active:focus,
    .dots-active:hover {
      background: #ef4e5e;
      width: 8px;
      height: 8px;
    }

    .image-gallery-thumbnail.active,
    .image-gallery-thumbnail:focus,
    .image-gallery-thumbnail:hover {
      border: none;
    }

    .image-gallery-thumbnail.active:hover {
      border: none;
    }
  }
`;

export const DeskTopMobile = styled.div`
  display: ${(props) => (props.desktop ? 'block' : 'none')};
  position: relative;
  @media (max-width: 720px) {
    display: ${(props) => (props.mobile ? 'block' : 'none')};
  }
`;

export const ProductDetailsTopSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
  @media (max-width: 720px) {
    padding: ${(props) => (props.sectionPadding ? '10px 12px 0' : '0')};
    display: ${(props) => (props.hideSection ? 'none' : 'block')};
  }

  .productName {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .features {
    font-size: clamp(13px, 2vw, 15px);
    color: #838383;
  }

  .featureChipContainer {
    display: flex;
    flex-wrap: wrap;
    column-gap: 14px;
    margin: 4px 0;
    row-gap: 8px;
    @media (min-width: 768px) {
      max-width: 80%;
    }
  }
`;
export const FeatureChip = styled.div`
  font-size: 12px;
  padding: 8px 12px;
  background: ${(props) => props.bgColor};
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 4px;

  img {
    width: 12px;
    height: 12px;
  }
`;
